import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyA4ieJCNqfuNwtj4l9c-qQJ6OEhJxPQFRg",
  authDomain: "wajls-admin.firebaseapp.com",
  projectId: "wajls-admin",
  storageBucket: "wajls-admin.firebasestorage.app",
  messagingSenderId: "629062160150",
  appId: "1:629062160150:web:159226a573db84195a8a37",
  measurementId: "G-JGL091WLCY"
};




// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const database = getDatabase(app);
const analytics = getAnalytics(app);

export { storage, database };
